import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SessionService } from './session.service';
import { Observable } from 'rxjs';
import { IEstadoResponse } from '../../models/cesion-facturas/estados-dte-cesion-facturas.models'
import { CesionFacturasResponse, EstadoCesionesResponse, EstadoCesionResponse, ICesionFacturas, IRegistro, MessageResponse } from '../../models/cesion-facturas/cesion-facturas.models';

@Injectable({
  providedIn: 'root'
})
export class CesionFacturasService {
  private servicio: string = environment.backend.cesionFacturas.servicio;
  private endpoint: string = environment.backend.cesionFacturas.url;

  constructor(
    private http: HttpClient,
    private _sessionService: SessionService
  ) { }

  obtenerPagina(rut: string, pagina: number, nElementos: number, filtros: any, isDescarga: boolean = false, orderCampos: any = null): Observable<ICesionFacturas> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "registros");

    if(pagina || pagina === 0) {
      params = params.append("pagina", pagina);
    }

    if(nElementos || nElementos === 0) {
      params = params.append("registrosPagina", nElementos);
    }

    if(filtros && Object.keys(filtros).length > 0) {
      for (const clave in filtros){
        params = params.append(clave, filtros[clave]);
      }
    }

    if(isDescarga) {
      params = params.append("xlsx", true);
    }

    if(orderCampos != null) {
      params = params.append("ordenarPor", `${orderCampos.campo}:${orderCampos.order}`);
    }

    return this.http.get<ICesionFacturas>(`${this.endpoint}obtener`, { params });
  }

  obtenerReportePorId(idOrganizacion: string, id: string): Observable<CesionFacturasResponse> { 
    let params = new HttpParams(); 
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", idOrganizacion ? idOrganizacion : this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("id_transaccion", id);
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "buscarTX");

    return this.http.get<CesionFacturasResponse>(`${this.endpoint}obtener`, { params });
  }

  crearReporte(idOrganizacion: string, rut: string, tipo: string, claveSii: string = '', isClaveOrg: boolean = true): Observable<CesionFacturasResponse> { 
    const payload: any = {
      rut: rut,
      idUsuario: this._sessionService.getUserInfo().username,
      idOrganizacion: idOrganizacion ? idOrganizacion : this._sessionService.getOrganization(),
      requestOrigin: "WEB",
      claveSii: claveSii,
      servicio: this.servicio,
      tipo: tipo,
      isClaveOrg: isClaveOrg,
      uri: "crearReporte/async",
    }
    return this.http.post<CesionFacturasResponse>(`${this.endpoint}crear`, payload);
  }

  actualizarDTE(idOrganizacion: string, rut: string, fechaInicio: string = '', fechaFin: string = ''): Observable<EstadoCesionesResponse> { 
    const payload: any = {
      rut: rut,
      idUsuario: this._sessionService.getUserInfo().username,
      idOrganizacion: idOrganizacion ? idOrganizacion : this._sessionService.getOrganization(),
      requestOrigin: "WEB",
      servicio: this.servicio,
      uri: "estadoCesiones",
    }
    
    if(fechaInicio)
      payload.fechaInicio = fechaInicio;
    if(fechaFin)
      payload.fechaFin = fechaFin;

    return this.http.post<EstadoCesionesResponse>(`${this.endpoint}crear`, payload);
  }

  actualizarDTEUnitario(rut: string, rutVendedor: string, folio: string, tipoDoc: string): Observable<IRegistro | MessageResponse> {
    const payload: any = {
      rut: rut,
      idUsuario: this._sessionService.getUserInfo().username,
      idOrganizacion: this._sessionService.getOrganization(),
      requestOrigin: "WEB",
      folio: folio,
      tipoDoc: tipoDoc,
      rutVendedor: rutVendedor,
      servicio: this.servicio,
      uri: "estadoCesion",
    }

    return this.http.post<IRegistro | MessageResponse>(`${this.endpoint}crear`, payload);
  }

  obtenerEstadoDTE(idOrganizacion: string, rut: string, fechaInicio: string, fechaFin: string): Observable<EstadoCesionResponse> { 
    let params = new HttpParams(); 
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", idOrganizacion ? idOrganizacion : this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("rut", rut);
    params = params.append("fechaInicio", fechaInicio);
    params = params.append("fechaFin", fechaFin);
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "estadoCesion");

    return this.http.get<EstadoCesionResponse>(`${this.endpoint}obtener`, {params});
  }

  actualizarEstadoPagado(rut: string, folio: string, tipoDoc: string, vendedor: string): Observable<MessageResponse> {
    const payload: any = {
      rut: rut,
      idUsuario: this._sessionService.getUserInfo().username,
      idOrganizacion: this._sessionService.getOrganization(),
      requestOrigin: "WEB",
      servicio: this.servicio,
      uri: "pago",
      tipoDoc: tipoDoc,
      rutVendedor: vendedor,
      folio: folio
    }

    return this.http.post<MessageResponse>(`${this.endpoint}crear`, payload);
  }

  obtenerEstados(): Observable<IEstadoResponse> {
    let params = new HttpParams(); 
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "estadosDte"); 

    return this.http.get<IEstadoResponse>(`${this.endpoint}obtener`, {params});
  }

  obtenerResumen(rut: string, pagina: number, nElementos: number, isDescarga: boolean = false): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "resumen"); 

    if(pagina || pagina === 0) {
      params = params.append("pagina", pagina);
    }

    if(nElementos || nElementos === 0) {
      params = params.append("registrosPagina", nElementos);
    }

    if(isDescarga) {
      params = params.append("xlsx", true);
    }

    return this.http.get<any>(`${this.endpoint}obtener`, {params});
  }

  obtenerFactorizacionDeudor(rut: string, pagina: number, nElementos: number, filtros: any, isDescarga: boolean = false): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "factorizacion/deudor"); 

    if(pagina || pagina === 0) {
      params = params.append("pagina", pagina);
    }

    if(nElementos || nElementos === 0) {
      params = params.append("registrosPagina", nElementos);
    }

    if(filtros && Object.keys(filtros).length > 0) {
      for (const clave in filtros){
        params = params.append(clave, filtros[clave]);
      }
    }

    if(isDescarga) {
      params = params.append("xlsx", true);
    }

    return this.http.get<any>(`${this.endpoint}obtener`, {params});
    
  }

  obtenerFactorizacionFactoring(rut: string, pagina: number, nElementos: number, filtros: any, isDescarga: boolean = false): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "factorizacion/factoring"); 

    if(pagina || pagina === 0) {
      params = params.append("pagina", pagina);
    }

    if(nElementos || nElementos === 0) {
      params = params.append("registrosPagina", nElementos);
    }

    if(filtros && Object.keys(filtros).length > 0) {
      for (const clave in filtros){
        params = params.append(clave, filtros[clave]);
      }
    }

    if(isDescarga) {
      params = params.append("xlsx", true);
    }

    return this.http.get<any>(`${this.endpoint}obtener`, {params});

  }

  obtenerListDeudor(rut: string, filtros: any): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "listadoDeudores");

    if(filtros && Object.keys(filtros).length > 0) {
      for (const clave in filtros){
        params = params.append(clave, filtros[clave]);
      }
    }

    return this.http.get<any>(`${this.endpoint}obtener`, {params});

  }

  obtenerListFactoring(rut: string, filtros: any): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "listadoCesionarios"); 

    if(filtros && Object.keys(filtros).length > 0) {
      for (const clave in filtros){
        params = params.append(clave, filtros[clave]);
      }
    }

    return this.http.get<any>(`${this.endpoint}obtener`, {params});

  }

  obtenerAtributosFactoring(rut: string): Observable<any> { 
    let params = new HttpParams(); 
    params = params.append("rut", rut);
    params = params.append("idUsuario", this._sessionService.getUserInfo().username);
    params = params.append("idOrganizacion", this._sessionService.getOrganization());
    params = params.append("requestOrigin", "WEB");
    params = params.append("servicio", this.servicio);
    params = params.append("uri", "resumen/atributos"); 

    return this.http.get<any>(`${this.endpoint}obtener`, { params });
    
  }

  actualizarRazonSocial(rut: string, atrituto: string): Observable<any> {
    const payload: any = {
      rut: rut,
      idUsuario: this._sessionService.getUserInfo().username,
      idOrganizacion: this._sessionService.getOrganization(),
      requestOrigin: "WEB",
      servicio: this.servicio,
      uri: "actualizarRazonSocial",
      atributo: atrituto
    }

    return this.http.post<any>(`${this.endpoint}crear`, payload);
  }

}
